module.exports = __webpack_public_path__ + "img/logo-type-outline.8dc9bebf.svg";